import axios from "axios";
import { BASE_URL } from "config/config";
import { getSubscriptionId } from "services/auth";
import { client } from "services/axios";
import { getFileNameFromUrl, getFileNameWithoutExtension } from "utils/utils";

const NODE_BASE_API = "https://node-server-api-877313306443.us-east1.run.app";

const CREATE_MATERIAL_FROM_SUBMITTAL_URL = `${NODE_BASE_API}/materials_from_submittals`;
const TRACK_AS_SINGLE_MATERIAL_URL = `${NODE_BASE_API}/materials`;

export const CreateMaterialFromSubmittalAPI = async (
  output: {
    materials: any;
  },
  token: any
) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`
    }
  };

  const res = await axios.post(
    CREATE_MATERIAL_FROM_SUBMITTAL_URL,
    output,
    config
  );
  return res;
};

export const TrackAsSingleMaterialAPI = async (
  materialData: any,
  token: any
) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`
    }
  };
  const res = await axios.post(
    TRACK_AS_SINGLE_MATERIAL_URL,
    materialData,
    config
  );
  return res;
};

export const extractUploadDrawingAPI = async ({
  specificationId,
  signedUrl,
  projectId
}: {
  specificationId: string;
  signedUrl: string;
  projectId: string;
}) => {
  const fileName = getFileNameFromUrl(signedUrl);
  const fileNameWithoutExt = getFileNameWithoutExtension(fileName || "");
  const res = await client.post(`${BASE_URL}/recommender-engine/extract`, {
    drawing_id: specificationId,
    file_name: fileNameWithoutExt,
    project_id: projectId,
    subscription_id: getSubscriptionId()
  });
  return res;
};

// export const getExtractionStatusAPI = async (specificationId: string) => {
//   const res = await client.get(
//     `${BASE_URL}/recommender-engine/extract/status/${specificationId}`
//   );
//   return res;
// };
